/* collins-home.js: the home's motion (COLLINS.md motions 2, 4, 5, 6) on the vendored GSAP 3.15 ScrollTrigger.
   Native scroll: COLLINS has no smooth-scroll layer, so Lenis is not started here.
     - the reel window grows from 80% to the full container (scale, never a clip: the whole film always shows),
       trailing the scroll by up to 90 px, scrubbed over the first screen of scrolling, eased out
     - the whole page crossfades to the dark ground when Work's top passes 60% of the viewport, and back
     - the cards grow to their full height on that switch, one after another
     - the card row drags with momentum on a desktop pointer; a phone swipes it natively
     - the reel plays only on screen, with a pause control that always wins
   Reduced motion: no ScrollTrigger at all; the CSS keeps the static grounds, the poster at full size, native scroll.
   Teardown: every trigger, listener, observer and frame is removed on pagehide and on shopify:section:unload. */
(function () {
  'use strict';
  var d = document, de = d.documentElement, w = window;
  var mqReduce = w.matchMedia('(prefers-reduced-motion: reduce)');
  var mqFine = w.matchMedia('(hover: hover) and (pointer: fine)');
  var S = null;

  function on(t, type, fn, opt) { t.addEventListener(type, fn, opt); S.off.push(function () { t.removeEventListener(type, fn, opt); }); }

  /* ---------- the reel: plays while on screen; the viewer's pause wins ---------- */
  function reel() {
    var v = d.querySelector('[data-cl-video]'), b = d.querySelector('[data-cl-pause]');
    if (!v || !b) return;
    if (v.hasAttribute('data-cl-desk') && w.matchMedia('(max-width: 767px)').matches) return;   /* a laptop-only film: the phone keeps its still, no button */
    var userPaused = false, visible = true;
    var attach = function () {
      var srcs = v.querySelectorAll('source[data-src]');
      if (!srcs.length) return;
      srcs.forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
      v.preload = 'auto'; v.load();
    };
    var play = function () { attach(); var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var label = function () { b.textContent = v.paused ? 'Play the reel' : 'Pause the reel'; };
    on(v, 'playing', function () { v.classList.add('is-on'); label(); });
    on(v, 'pause', label);
    on(b, 'click', function () {
      if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); }
      label();
    });
    b.hidden = false; label();
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          visible = e.isIntersecting;
          if (!visible) { if (!v.paused) v.pause(); }
          else if (!userPaused && !mqReduce.matches && v.querySelector('source[src]')) play();
        });
      }, { threshold: 0.15 });
      io.observe(v);
      S.off.push(function () { io.disconnect(); });
    }
  }

  /* ---------- the card row: pointer drag with momentum (desktop), native swipe (phone) ---------- */
  function drag() {
    var track = d.querySelector('[data-cl-track]');
    if (!track || !mqFine.matches) return;
    var down = false, captured = false, id = 0, x0 = 0, s0 = 0, moved = 0, vx = 0, lastX = 0, lastT = 0, raf = 0;
    var glide = function () {
      vx *= 0.93;
      track.scrollLeft -= vx;
      if (Math.abs(vx) > 0.35) raf = w.requestAnimationFrame(glide);
    };
    on(track, 'dragstart', function (e) { e.preventDefault(); });
    on(track, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      w.cancelAnimationFrame(raf);
      down = true; captured = false; id = e.pointerId; moved = 0; vx = 0;
      x0 = lastX = e.clientX; s0 = track.scrollLeft; lastT = performance.now();
    });
    on(track, 'pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 6 && !captured) { captured = true; track.setPointerCapture(id); track.classList.add('is-dragging'); }
      if (!captured) return;
      track.scrollLeft = s0 - dx;
      var t = performance.now(), dt = Math.max(1, t - lastT);
      vx = 0.8 * ((e.clientX - lastX) * (16.7 / dt)) + 0.2 * vx;
      lastX = e.clientX; lastT = t;
    });
    var up = function () {
      if (!down) return;
      down = false;
      if (captured) {
        try { track.releasePointerCapture(id); } catch (err) {}
        w.setTimeout(function () { track.classList.remove('is-dragging'); }, 0);
        if (!mqReduce.matches && performance.now() - lastT < 80) raf = w.requestAnimationFrame(glide);
      }
    };
    on(track, 'pointerup', up);
    on(track, 'pointercancel', up);
    on(track, 'click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    S.off.push(function () { w.cancelAnimationFrame(raf); track.classList.remove('is-dragging'); });
  }

  /* ---------- the scroll work (motion only) ---------- */
  function motion() {
    if (mqReduce.matches || !w.gsap || !w.ScrollTrigger) return;
    var gsap = w.gsap, ST = w.ScrollTrigger;
    gsap.registerPlugin(ST);
    var win = d.querySelector('[data-cl-win]'), work = d.querySelector('[data-cl-work]');
    var cards = Array.prototype.slice.call(d.querySelectorAll('[data-cl-card]'));
    de.classList.add('cl-motion');
    de.setAttribute('data-cl-ground', 'light');
    var made = [];

    if (win) {
      var lag = parseFloat(w.getComputedStyle(de).getPropertyValue('--cl-win-lag')) || 90;
      made.push(gsap.fromTo(win, { '--s': 0.8, '--lag': '0px' }, {
        '--s': 1, '--lag': lag + 'px', ease: 'power1.out',
        scrollTrigger: { trigger: d.body, start: 'top top', end: function () { return '+=' + Math.max(1, w.innerHeight - 60); }, scrub: true, invalidateOnRefresh: true }
      }));
    }

    var cardsIn = function () { cards.forEach(function (c, i) { c.style.transitionDelay = '0ms, ' + (i * 90) + 'ms'; c.classList.add('is-in'); }); };   /* transform (hover) stays instant; the clip waits its turn */
    var cardsOut = function () { cards.forEach(function (c) { c.style.transitionDelay = ''; c.classList.remove('is-in'); }); };
    if (work) {
      /* STOP E (17 Oct 2026): the switch waits until the block before the work is nearly off screen (its bottom at
         20% of the viewport), so the list above never splits across two grounds; without one, Work's top at 60%. */
      var host = work.closest('.shopify-section') || work;
      var prev = host.previousElementSibling;
      while (prev && !(prev.offsetHeight > 0)) prev = prev.previousElementSibling;
      made.push(ST.create({
        trigger: prev || work, start: prev ? 'bottom 20%' : 'top 60%',
        onEnter: function () { de.setAttribute('data-cl-ground', 'dark'); cardsIn(); },
        onLeaveBack: function () { de.setAttribute('data-cl-ground', 'light'); cardsOut(); }
      }));
    }
    var refresh = function () { ST.refresh(); };
    on(w, 'load', refresh);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { if (S) ST.refresh(); });

    S.off.push(function () {
      made.forEach(function (m) { if (m.scrollTrigger) m.scrollTrigger.kill(); if (m.kill) m.kill(); });
      if (win) { win.style.removeProperty('--s'); win.style.removeProperty('--lag'); }
      cards.forEach(function (c) { c.classList.remove('is-in'); c.style.transitionDelay = ''; });
      de.classList.remove('cl-motion');
      de.removeAttribute('data-cl-ground');
    });
  }

  function init() {
    if (S || !d.querySelector('[data-cl-win], [data-cl-work]')) return;
    S = { off: [] };
    reel(); drag(); motion();
  }
  function destroy() {
    if (!S) return;
    var off = S.off; S = null;
    for (var i = off.length - 1; i >= 0; i--) { try { off[i](); } catch (e) {} }
  }

  var ours = function (e) { return e.target && e.target.querySelector && e.target.querySelector('[data-cl-win], [data-cl-work], [data-cl-services], [data-cl-intro]'); };
  d.addEventListener('shopify:section:unload', function (e) { if (ours(e)) destroy(); });
  d.addEventListener('shopify:section:load', function (e) { if (ours(e)) { destroy(); init(); } });
  /* STOP Q (26 Oct 2026, the owner's yes on call 1): a page going into the back-forward cache keeps everything as it is, so it comes
     back exactly as it was left (tearing down here put the static layout back for the return: a 0.28 layout shift,
     the ground fading in again, the cards growing again). Only a page that is really unloaded is torn down. */
  w.addEventListener('pagehide', function (e) { if (!e.persisted) destroy(); });
  w.addEventListener('pageshow', function (e) { if (e.persisted && !S) init(); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
